import PAIAA010 from '../../pages/MyPage/PAIAA010';
import PAIAB010 from '../../pages/MyPage/PAIAB010';
import PAIAB020 from '../../pages/MyPage/PAIAB020';
// import PAIAB030 from '../../pages/MyPage/PAIAB030';
import PAIAB030 from '../../pages/MyPage/PAIAB030';
import PAIAC010 from '../../pages/MyPage/PAIAC010';
import PAIAD010 from '../../pages/MyPage/PAIAD010';
import PAIAE010 from '../../pages/MyPage/PAIAE010';
import PAIAF010 from '../../pages/MyPage/PAIAF010';

import PAIAF020 from '../../pages/MyPage/PAIAF020';
import PAIAF030 from '../../pages/MyPage/PAIAF030';
import PAIAH020 from '../../pages/MyPage/PAIAH020';
import PAIAH030 from '../../pages/MyPage/PAIAH030';

import PAJAA010 from '../../pages/MyPage/PAJAA010';
import PAJAB010 from '../../pages/MyPage/PAJAB010';
import PAJAB020 from '../../pages/MyPage/PAJAB020';
import PAJAC010 from '../../pages/MyPage/PAJAC010';
import PAJAD010 from '../../pages/MyPage/PAJAD010';
import PAJAE010 from '../../pages/MyPage/PAJAE010';
import PAJAF010 from '../../pages/MyPage/PAJAF010';
import PAJAG010 from '../../pages/MyPage/PAJAG010';
import PAJAH010 from '../../pages/MyPage/PAJAH010';
import PAJAH020 from '../../pages/MyPage/PAJAH020';
import PAJAI010 from '../../pages/MyPage/PAJAI010';
import PAJAJ010 from '../../pages/MyPage/PAJAJ010';
import PAJAJ040 from '../../pages/MyPage/PAJAJ040';
import PAJAK010 from '../../pages/MyPage/PAJAK010';
import PAJAL010 from '../../pages/MyPage/PAJAL010';

import RegisterJob from '../../pages/MyPage/RegisterJob';
import withPassword from '../../shared/hocs/WithPassword';
import withSecondPassword from '../../shared/hocs/WithSecondPassword';

const routersSub = [
    { path: '/paiaa010', element: PAIAA010 },
    { path: '/paiab010', element: PAIAB010 },
    { path: '/paiab010-:id', element: PAIAB010 },
    { path: '/paiab020', element: PAIAB020 },
    { path: '/paiab020-:id', element: PAIAB030 },
    { path: '/paiac010', element: PAIAC010 },
    { path: '/paiad010', element: PAIAD010 },
    { path: '/paiae010', element: PAIAE010 },
    { path: '/paiaf010', element: PAIAF010 },
    { path: '/paiaf030', element: PAIAF030 },

    { path: '/paiaf020-:id', element: PAIAF020 },
    { path: '/paiah020', element: withPassword(PAIAH020) },
    { path: '/paiah030', element: PAIAH030 },

    { path: '/pajaa010', element: withSecondPassword(PAJAA010) },
    { path: '/pajab010', element: withSecondPassword(PAJAB010) },
    { path: '/pajab020', element: withSecondPassword(PAJAB020) },
    { path: '/pajac010', element: withSecondPassword(PAJAC010) },
    { path: '/pajad010', element: withSecondPassword(PAJAD010) },
    { path: '/pajac020', element: withSecondPassword(RegisterJob) },
    { path: '/pajac020-:id', element: withSecondPassword(RegisterJob) },
    { path: '/pajae010', element: withSecondPassword(PAJAE010) },
    { path: '/pajaf010', element: withSecondPassword(PAJAF010) },
    { path: '/pajag010', element: withSecondPassword(PAJAG010) },
    { path: '/pajah010', element: withSecondPassword(PAJAH010) },
    { path: '/pajah020-:id', element: withSecondPassword(PAJAH020) },
    { path: '/pajai010', element: withSecondPassword(PAJAI010) },
    { path: '/pajaj010', element: withSecondPassword(PAJAJ010) },
    { path: '/pajak010', element: withSecondPassword(PAJAK010) },
    { path: '/pajal010', element: withSecondPassword(PAJAL010) },
    { path: '/pajaj020', element: withSecondPassword(withPassword(PAIAH020)) },
    { path: '/pajaj030', element: withSecondPassword(withPassword(PAIAH020)) },
    { path: '/pajaj040', element: withSecondPassword(PAJAJ040) },
];

export default routersSub;
